import { takeLatest, put, select } from "redux-saga/effects";
import { USER_USERNAME_CHANGED } from "../../actions/users";
import { pathnameSelector } from "sc/selectors/ui";
import { replace } from "react-router-redux/actions";

const changedUsername = function*(action) {
  const currentPathname = yield select(pathnameSelector);
  const pathnameComponents = currentPathname.split("/");
  pathnameComponents.pop();
  pathnameComponents.push(action.payload.username);
  yield put(replace(pathnameComponents.join("/")));
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(USER_USERNAME_CHANGED, changedUsername);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/users/changed-username.js